import React, { useRef } from 'react';
import { Box, Container } from '@chakra-ui/react';
import parse from 'html-react-parser';
import { INewsletterData } from '@/constants/pages/newsletter';

const NoSSRComponent: React.FC<{
  NewsletterData?: INewsletterData;
}> = ({ NewsletterData }) => {
  const boxRef = useRef<HTMLDivElement>(null);
  //   const [newsletterDataState, setNewsletterDataState] =
  //     useState<INewsletterData | null>(null);

  //   const { width } = useWindowSize();

  //   useEffect(() => {
  //     if (width) {
  //       if (width > 1000) {
  //         setNewsletterDataState({
  //           ...(NewsletterData as any),
  //         });
  //       } else {
  //         let newsletterDataCopy = NewsletterData?.html || '';
  //         const widthArr = Array?.from(
  //           new Set(newsletterDataCopy?.match(/width="\d{1,3}"/g))
  //         );

  //         // Step 1: Find the minimum and maximum values in the array
  //         const min = Math.min(
  //           ...widthArr.map((item) => Number(item?.match(/\d{1,3}/g)?.[0]))
  //         );
  //         const max = Math.max(
  //           ...widthArr.map((item) => Number(item?.match(/\d{1,3}/g)?.[0]))
  //         );

  //         console.log({ widthArr });

  //         // Step 2: Normalize the numbers to a scale of min to 100
  //         const normalizedWidthArr = widthArr.map((item) => {
  //           const num = Number(item?.match(/\d{1,3}/g)?.[0]);
  //           return ((num - min) / (max - min)) * (100 - min) + min;
  //         });

  //         widthArr?.forEach((item, index) => {
  //           const numericValue = normalizedWidthArr?.[index];

  //           newsletterDataCopy = newsletterDataCopy?.replaceAll(
  //             item,
  //             `width="${numericValue}%"`
  //           );
  //         });

  //         setNewsletterDataState({
  //           ...(NewsletterData as any),
  //           html: newsletterDataCopy,
  //         });
  //       }
  //     }
  //   }, [width, NewsletterData]);

  return (
    <Container maxW="1199px" pt={{ xs: '24px', lg: '36px' }} pb="11.25rem">
      {NewsletterData?.html && (
        <Box ref={boxRef} overflow={{ xs: 'visible', md: 'auto' }}>
          {parse(NewsletterData?.html || '')}
        </Box>
      )}
    </Container>
  );
};
export default NoSSRComponent;
